/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line import/named
import { API_EVENTS, CLASS_PACK_EVENTS } from '../constants/actionTypes';

export const initialState = {
  loading: false,
  data: null,
  error: null,
  peakNonPeakStatus: [], // '1' /* Peak */, '2' /* Non Peak */
};

const classPackReducer = (state, { type, payload }) => {
  switch (type) {
    case API_EVENTS.REQUEST:
      // case STAFF_MEMBER_EVENTS.REMOVE_REQUEST:
      return { ...state, loading: true };

    case API_EVENTS.FAIL:
      // case STAFF_MEMBER_EVENTS.REMOVE_FAIL:
      return { ...state, loading: false, error: payload };

    case API_EVENTS.SUCCESS:
      // case STAFF_MEMBER_EVENTS.REMOVE_SUCCESS:
      return { ...state, loading: false, data: payload };
    case CLASS_PACK_EVENTS.DELETE_SUCCESS:
      return { ...state, loading: false };

    case CLASS_PACK_EVENTS.SET_PEAK_NON_PEAK_STATUS:
      return { ...state, peakNonPeakStatus: payload };
    default:
      return state;
  }
};

export default classPackReducer;
